<template>
  <div class="rn-notarios-area notarios-area rn-section-gap bg_color--1">
    <v-container>
      <v-row class="mt--30">
        <div class="rn-content-box-area rn-content-box-style--1 bg_color--1" id="notarios">
          <v-row class="row--10 mb-10" align="center" v-for="notario in NOTARIA.Notarios" :key="notario.id">
            <v-col lg="6" md="12" cols="12" v-if="notario.Imagen !== ''">
              <div class="thumbnail">
                <img :src="imagenIDtoSRC(notario.Imagen)" alt="Imagen del Notario" />
              </div>
            </v-col>
            <!-- End .v-col -->
            <v-col md="12" lg="6" cols="12" class="mt_lg--50 mt_md--30 mt_sm--30">
              <div class="notarios-card">
                <h3>
                  {{ notario.Nombre }}
                </h3>

                <p v-html="notario.Descripcion.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>

                <a :title="'Enviar email a ' + notario.Nombre" :href="'mailto:' + notario.Email" v-if="notario.Email" class="ml-6">
                  <v-icon :color="NOTARIA.Theme.Notarios.Tarjeta.Titulo.css.Color">
                    mdi-email
                  </v-icon>
                </a>
                <a title="Abrir pagina web del notario" :href="notario.Web" v-if="notario.Web">
                  <v-icon :color="NOTARIA.Theme.Notarios.Tarjeta.Titulo.css.Color">
                    mdi-web
                  </v-icon>
                </a>

              </div>
            </v-col>
            <!-- End .col -->
          </v-row>

        </div>
        <!-- Start Content Box -->
      </v-row>
    </v-container>
  </div>
</template>
<script setup lang="ts">
import { useStore } from '../../store/index'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()

import { useStyles } from '../../store/styles';
const style = useStyles();

// const estiloTituloColor = style.ThemeSectionNotario.Titulo.css.Color
// const estiloTituloShadow = style.ThemeSectionNotario.Titulo.css.BackgroundColor ? "4px 2px 6px "+style.ThemeSectionNotario.Titulo.css.BackgroundColor:""
// const estiloTituloFont = style.ThemeSectionNotario.Titulo.css.Font
// const estiloTituloSize = style.ThemeSectionNotario.Titulo.css.Size
// const estiloTituloWeight = style.ThemeSectionNotario.Titulo.css.Weight
// const estiloTituloAlign = style.ThemeSectionNotario.Titulo.css.Align

// const estiloDescripcionColor = style.ThemeSectionNotario.Descripcion.css.Color
// const estiloDescripcionShadow = style.ThemeSectionNotario.Descripcion.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionNotario.Descripcion.css.BackgroundColor:""
// const estiloDescripcionFont = style.ThemeSectionNotario.Descripcion.css.Font
// const estiloDescripcionSize = style.ThemeSectionNotario.Descripcion.css.Size
// const estiloDescripcionWeight = style.ThemeSectionNotario.Descripcion.css.Weight
// const estiloDescripcionAlign = style.ThemeSectionNotario.Descripcion.css.Align

const estiloTarjetaTituloColor = style.ThemeSectionNotario.Tarjeta.Titulo.css.Color
const estiloTarjetaTituloShadow = style.ThemeSectionNotario.Tarjeta.Titulo.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionNotario.Tarjeta.Titulo.css.BackgroundColor:""
const estiloTarjetaTituloFont = style.ThemeSectionNotario.Tarjeta.Titulo.css.Font
const estiloTarjetaTituloSize = style.ThemeSectionNotario.Tarjeta.Titulo.css.Size
const estiloTarjetaTituloWeight = style.ThemeSectionNotario.Tarjeta.Titulo.css.Weight
const estiloTarjetaTituloAlign = style.ThemeSectionNotario.Tarjeta.Titulo.css.Align

const estiloTarjetaDescripcionColor = style.ThemeSectionNotario.Tarjeta.Descripcion.css.Color
const estiloTarjetaDescripcionShadow = style.ThemeSectionNotario.Tarjeta.Descripcion.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionNotario.Tarjeta.Descripcion.css.BackgroundColor:""
const estiloTarjetaDescripcionFont = style.ThemeSectionNotario.Tarjeta.Descripcion.css.Font
const estiloTarjetaDescripcionWeight = style.ThemeSectionNotario.Tarjeta.Descripcion.css.Weight
const estiloTarjetaDescripcionSize = style.ThemeSectionNotario.Tarjeta.Descripcion.css.Size
const estiloTarjetaDescripcionAlign = style.ThemeSectionNotario.Tarjeta.Descripcion.css.Align

</script>
<style lang="scss">
  .notarios-card h3{
    color:v-bind(estiloTarjetaTituloColor)  !important;
    text-shadow:v-bind(estiloTarjetaTituloShadow)  !important;
    font-size:v-bind(estiloTarjetaTituloSize) !important;
    font-family: v-bind(estiloTarjetaTituloFont) !important;
    font-weight:v-bind(estiloTarjetaTituloWeight) !important;
    text-align:v-bind(estiloTarjetaTituloAlign)  !important;
  }
  .notarios-card p{
    color:v-bind(estiloTarjetaDescripcionColor)  !important;
    text-shadow:v-bind(estiloTarjetaDescripcionShadow)  !important;
    font-family:v-bind(estiloTarjetaDescripcionFont)  !important;
    font-size: v-bind(estiloTarjetaDescripcionSize) !important;
    font-weight:v-bind(estiloTarjetaDescripcionWeight) !important;
    text-align:v-bind(estiloTarjetaDescripcionAlign)  !important;
  }
  .notarios-card a{
    color:v-bind(estiloTarjetaTituloColor)  !important;
    float: v-bind(estiloTarjetaTituloAlign) !important;
  }

</style>